<template>
  <md-card>
    <md-card-content>

      <div class="md-layout">
        <div class="md-layout-item">
          <autoextra :collection="accesories" v-slot="{item,last,index}">
            <div  :class="{last: last}">
              <div v-if="item.vehicle_accesory_type || item.vehicle_accesory_type == 0 || last" class="columns">
                <label :id="'labelAccesoriesFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Accesories {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Accesories Type</label>
                      <md-select v-model="item.vehicle_accesory_type" @md-selected="onChangeAccesoriesType()">
                        <md-option value="0">RDS+SIM-CARD</md-option>
                        <md-option value="1">Bracket RDS</md-option>
                        <md-option value="2">Crown</md-option>
                        <md-option value="3">Emergency Lamp</md-option>
                        <md-option value="4">Vacancy Lamp</md-option>
                        <md-option value="5">Sticker</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Series No</label>
                      <md-input v-model="item.vehicle_accesory_serial_no" :disabled="!item.vehicle_accesory_type && item.vehicle_accesory_type != 0" @change="onChangeSeriesNo(index, item.vehicle_accesory_serial_no)"/>
                    
                    </md-field>
                    <span :id="'flagSeriesNo_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                      <label class="md-layout-item md-size-15 md-form-label" >Installation Date</label>
                    <md-field >
                      <md-input type="date" v-model="item.vehicle_accesory_installation_date"  :disabled="!item.vehicle_accesory_type && item.vehicle_accesory_type != 0"/>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Installation By</label>
                      <md-input v-model="item.vehicle_accesory_installation_by" :disabled="!item.vehicle_accesory_type && item.vehicle_accesory_type != 0"/>
                    </md-field>
                  </div>
                  
                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-textarea v-model="item.vehicle_accesory_remark" md-counter="150" maxlength="150" :disabled="!item.vehicle_accesory_type && item.vehicle_accesory_type != 0" md-autogrow></md-textarea>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Upload File/Photo</label>
                    <md-field class="md-invalid">
                      <md-file 
                      ref="stnk"
                        @change="on_change_attach_acc(item.vehicle_attach_accesories_view,index)"
                        v-model="item.vehicle_attach_accesories_view"
                        accept="image/jpeg,image/png,application/pdf"
                        :disabled="!item.vehicle_accesory_type && item.vehicle_accesory_type != 0"
                      />
                      <validation-error
                        :errors="apiValidationErrors.vehicle_accesory_attach"
                      />
                    </md-field>
                    <p v-if="item.vehicle_accesory_attach && item.vehicle_accesory_attach.type != 'image/jpeg' && item.vehicle_accesory_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.vehicle_accesory_attach.size / 1048576).toFixed(2) }}MB</p>
                  </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                    <div class="border p-2 mt-3">
                      <template v-if="item.vehicle_accesory_attach && (item.vehicle_accesory_attach.type == 'image/jpeg' || item.vehicle_accesory_attach.type == 'image/png')">
                        <viewer class="pointer">
                        <img style="width: auto; max-height:400px; display: block; margin:auto;"
                          :src="item.vehicle_accesory_attach.base64"
                          class="img-fluid"
                        />
                        </viewer>
                        <!-- <p class="mb-0">file name: {{ file_attach_accesories.name }}</p> -->
                        <p class="mb-0">size: {{ (item.vehicle_accesory_attach.size / 1048576).toFixed(2) }}MB</p>
                      </template>
                      <template v-if="!item.vehicle_accesory_attach && item.url_vehicle_accessory_file">
                      <!-- <template v-if="!file_attach_accesories && item.url_vehicle_accessory_file"> -->
                        <template v-if="get_url_extension_image(item.url_vehicle_accessory_file)">
                          <span style="color:green"
                            >Current Photo:
                          </span>
                          <viewer class="pointer">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;"
                              :src="item.url_vehicle_accessory_file"
                              
                              class="img-fluid"
                            />
                          </viewer>
                        </template>
                        <template v-else>
                          <span style="color:green"
                            >Current File:
                          </span>
                          <a target="_blank" :href="item.url_vehicle_accessory_file">{{item.url_vehicle_accessory_file.split('/').pop()}}</a>
                        </template>
                        <!-- <span style="color:green">
                            Current Document:
                          </span>
                          <a v-if="item.url_vehicle_accessory_file" :href="item.url_vehicle_accessory_file" target="_blank">
                          stnk_{{ item.vehicle_police_no }}
                          </a> -->
                      </template>
                    </div>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.vehicle_accesory_type || item.vehicle_accesory_type==0">
                    delete
                  </md-button>
                  </md-card-actions>
                </div>            
              </div>
            </div>
            </autoextra>
          </div>
        </div>

        
        
    </md-card-content>
  </md-card>
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import  Autoextra  from 'vue-autoextra';
import Swal from "sweetalert2";

extend("category", {
  ...required,
  message: "Category field is required",
});
extend("policeno", {
  ...required,
  message: "Police No. field is required",
});
extend("model", {
  ...required,
  message: "Model field is required",
});
extend("sensor", {
  ...required,
  message: "Sensor field is required",
});
export default {
  name: "vehicle-card",

   props: ["vehicle"],

  components: { ValidationError, Autoextra },

  mixins: [formMixin],
  
  data() {
    return {
    accesories:[],
    
    };
  },

//   created() {
//     this.onOpen();
//   },

  methods: {

    onChangeSeriesNo(index,data){
        let error = document.getElementById("flagSeriesNo_"+index);
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

      getData() {
            // this.$emit('data', this.accesories)
            this.vehicle.accesories = this.accesories
        },

      

    async getDataParent() { 
        // console.log(this.driver.vehicle_document);
        // this.identity = this.driver.vehicle_document
        //loop nilai identity untuk membuat autoextra row
        this.vehicle.vehicle_accessory.forEach((value, index) => {
          this.$set(this.accesories, index, {
                  id : value.id,
                  vehicle_accesory_type : value.vehicle_accesory_type,
                  vehicle_accesory_serial_no : value.vehicle_accesory_serial_no,
                  vehicle_accesory_installation_date : value.vehicle_accesory_installation_date,
                  vehicle_accesory_installation_by : value.vehicle_accesory_installation_by,
                  vehicle_accesory_remark : value.vehicle_accesory_remark,
                  vehicle_accesory_attach : value.vehicle_accesory_attach,
                  vehicle_attach_accesories_view : value.vehicle_attach_accesories_view,
                  url_vehicle_accessory_file : value.url_vehicle_accessory_file

                });
          });
        console.log(this.accesories);
      },

      onChangeAccesoriesType(){
      var filter = this.accesories.filter(function(el) {
           console.log(el);
            return el != null;
          });
          console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        console.log(key);
                        console.log(value);
                        if(!value.vehicle_accesory_type  && value.vehicle_accesory_type != 0){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.accesories, key-int, {
                             id : value.id,
                            vehicle_accesory_type : value.vehicle_accesory_type,
                            vehicle_accesory_serial_no : value.vehicle_accesory_serial_no,
                            vehicle_accesory_installation_date : value.vehicle_accesory_installation_date,
                            vehicle_accesory_installation_by : value.vehicle_accesory_installation_by,
                            vehicle_accesory_remark : value.vehicle_accesory_remark,
                            vehicle_accesory_attach : value.vehicle_accesory_attach,
                            vehicle_attach_accesories_view : value.vehicle_attach_accesories_view,
                            url_vehicle_accessory_file : value.url_vehicle_accessory_file,
                            
                          });
                          if(int!=0){
                            this.$set(this.accesories, key, {
                               id :null,
                              vehicle_accesory_type : null,
                              vehicle_accesory_serial_no : null,
                              vehicle_accesory_installation_date : null,
                              vehicle_accesory_installation_by : null,
                              vehicle_accesory_remark : null,
                              vehicle_accesory_attach : null,
                              vehicle_attach_accesories_view : null,
                              url_vehicle_accessory_file : null,
                              
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      
    },

    on_change_attach_acc(event,index) {
        console.log(index)
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.vehicle_accesory_attach = null
          // this.vehicle_accesory_attach = null
          console.log(input)
          this.$set(this.accesories, index, {
                  id : this.accesories[index].id,
                  vehicle_accesory_type : this.accesories[index].vehicle_accesory_type,
                  vehicle_accesory_serial_no : this.accesories[index].vehicle_accesory_serial_no,
                  vehicle_accesory_installation_date : this.accesories[index].vehicle_accesory_installation_date,
                  vehicle_accesory_installation_by : this.accesories[index].vehicle_accesory_installation_by,
                  vehicle_accesory_remark : this.accesories[index].vehicle_accesory_remark,
                  vehicle_accesory_attach : null,
                  vehicle_attach_accesories_view : null,
                  url_vehicle_accessory_file : this.accesories[index].url_vehicle_accessory_file
                  
                });

          
          //console.log(this.vehicle_accesory_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.vehicle_accesory_attach = fileData;

           this.$set(this.accesories, index, {
                  id : this.accesories[index].id,
                  vehicle_accesory_type : this.accesories[index].vehicle_accesory_type,
                  vehicle_accesory_serial_no : this.accesories[index].vehicle_accesory_serial_no,
                  vehicle_accesory_installation_date : this.accesories[index].vehicle_accesory_installation_date,
                  vehicle_accesory_installation_by : this.accesories[index].vehicle_accesory_installation_by,
                  vehicle_accesory_remark : this.accesories[index].vehicle_accesory_remark,
                  vehicle_accesory_attach : this.accesories[index].vehicle_accesory_attach,
                  vehicle_accesory_attach : fileData,
                   vehicle_attach_accesories_view : fileData.name,
                  url_vehicle_accessory_file : this.accesories[index].url_vehicle_accessory_file
                  
                });

        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    async validateForm() {
      
      let result = []
      if(Object.keys(this.accesories).length != 0){
        // console.log(this.result.push(false));
        for (const [key, value] of Object.entries(this.accesories)) {
          if((value.vehicle_accesory_type || value.vehicle_accesory_type == 0) && !value.vehicle_accesory_serial_no){
            document.getElementById("flagSeriesNo_"+key).style.display = "block"
            document.getElementById("labelAccesoriesFlag_"+key).scrollIntoView({behavior: 'auto'});
            result.push(false)
          }
        }
      }
              return result.every(Boolean)

    },

    deleteColumn(index){
        if (index > -1) {
           this.accesories.splice(index, 1)
        }
        
      },

    get_url_extension_image(url) {
        const image_format = ["jpg", "jpeg", "pjpeg", "pjp", "png", "svg", "webp"];
        return image_format.includes(url.split(/[#?]/)[0].split('.').pop().trim());
    },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },
     resetFile(ref) {
      this.$refs[ref].clearField()
    },
    
    
  },
};
</script>

<style>
.pointer {cursor: pointer;}
.photo_list{
    display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}</style>
